<one-card class="no-padding">
  <one-dynamic-table #table [tableData]="licensesTableData"></one-dynamic-table>
</one-card>
